import type { DonationGoal } from '@zs/shared/schema';

interface Props {
  goal: DonationGoal;
}

export function GoalCard({ goal }: Props) {
  const progress = (goal.currentAmount / goal.targetAmount) * 100;

  return (
    <div className="goal-card">
      <h3>{goal.title}</h3>
      {goal.description && <p>{goal.description}</p>}
      <div className="progress-bar">
        <div className="progress" style={{ width: `${Math.min(progress, 100)}%` }} />
      </div>
      <p className="amounts">
        <span>¥{goal.currentAmount.toLocaleString()}</span>
        <span>¥{goal.targetAmount.toLocaleString()}</span>
      </p>
    </div>
  );
}
